function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null);

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 38.15,
  y1: 84.912,
  x2: 38.15,
  y2: 22.028
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0000b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.009,
  stopColor: "#0000b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000050"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M46.4 24.6c-.7-.1-1.3-.1-2-.1-4.9 0-9.7 2-14 5.8-2 1.8-3.9 4-5.6 6.4-.3-9.3-.8-19.2-1.8-29.3H10.5c2.7 28.4 2.4 53.2 1.9 75v.1h12.5c.4-21.8 5.8-35.8 13.9-43 2.2-1.9 4.3-2.8 6.2-2.6 9.9 1.1 8.3 31.9 7.6 45.6h12.5c.5-10.1 1.1-22.4-.3-33-2-15.5-8.3-23.8-18.4-24.9z",
  fill: "url(#prefix__SVGID_1_)"
});

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 158.577,
  y1: 84.912,
  x2: 158.577,
  y2: 22.028
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0000b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.009,
  stopColor: "#0000b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000050"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M174.2 26.5c-3-1.4-6.2-2.1-9.4-2.1-3.3 0-6.6.7-9.9 2.2-9 4.1-16.5 13.5-20 25.2-5.4 18-5.1 39.6-5 53.9v1.1h12.5v-1.2c-.1-13.5-.4-34 4.5-50.2 2.4-8.2 7.5-14.8 13.2-17.4 3.1-1.4 6.1-1.4 8.8-.2 2.9 1.4 4.4 4.3 5 6.6 1.6 5.2.8 11.5-2.1 16-4.5 7.3-10.7 9.9-22.1 9.6v12.4c12 .1 25.1-2.7 32.8-15.5 4.6-7.6 6-17.6 3.4-26.2-1.9-6.5-6.1-11.6-11.7-14.2z",
  fill: "url(#prefix__SVGID_2_)"
});

var _ref7 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 99.356,
  y1: 84.912,
  x2: 99.356,
  y2: 22.028
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0000b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.009,
  stopColor: "#0000b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000050"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M99.4 24.1c-16.1 0-29.1 13.4-29.1 29.9s13.1 29.9 29.1 29.9c16.1 0 29.1-13.4 29.1-29.9s-13.1-29.9-29.1-29.9zm0 47.3c-9.2 0-16.6-7.8-16.6-17.4 0-9.6 7.4-17.4 16.6-17.4 9.2 0 16.6 7.8 16.6 17.4 0 9.6-7.5 17.4-16.6 17.4z",
  fill: "url(#prefix__SVGID_3_)"
});

var _ref9 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__SVGID_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 215.36,
  y1: 84.912,
  x2: 215.36,
  y2: 22.028
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0000b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.009,
  stopColor: "#0000b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000050"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M220.5 24.1c-4.6 0-8.8 1.7-12.5 5.1-1.4 1.3-2.7 2.8-3.9 4.4-.3-2.6-.6-5.3-.9-8.1h-12.6c3 22.3 2.7 40.7 2.5 52 0 1.7-.1 3.2-.1 4.5v.4h12.5c.1-8.4.4-15.1 2.3-25.3C209.7 47 215.3 36 221 36.6c4.5.4 6 5.8 6.5 10.8h12.6c-.7-15-9.2-23.3-19.6-23.3z",
  fill: "url(#prefix__SVGID_4_)"
});

function SvgHoprLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 249.3 113.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoprLogo);
export default __webpack_public_path__ + "static/media/hopr_logo.97ffaaf3.svg";
export { ForwardRef as ReactComponent };